angular.module('sms.common.services').service('gradeService', gradeService)

function gradeService() {
  const service = {}
  service.grades = [
    { value: 'K', adult: false, display: 'Kindergarten' },
    { value: '1', adult: false, display: 'Grade 1' },
    { value: '2', adult: false, display: 'Grade 2' },
    { value: '3', adult: false, display: 'Grade 3' },
    { value: '4', adult: false, display: 'Grade 4' },
    { value: '5', adult: false, display: 'Grade 5' },
    { value: '6', adult: false, display: 'Grade 6' },
    { value: '7', adult: false, display: 'Grade 7' },
    { value: '8', adult: false, display: 'Grade 8' },
    { value: '9', adult: false, display: 'Grade 9' },
    { value: '10', adult: false, display: 'Grade 10' },
    { value: '11', adult: false, display: 'Grade 11' },
    { value: '12', adult: false, display: 'Grade 12' },
    { value: 'G', adult: false, display: 'Graduated' },
    { value: 'GA', adult: true, display: 'Graduated Adult' },
    { value: 'UA', adult: true, display: 'Ungraduated Adult' }
  ]
  service.isAdult = function (grade) {
    return _.get(_.find(service.grades, { value: grade }), 'adult', false)
  }
  service.isStudent = function (grade) {
    const grades = _.map(service.grades, 'value')
    return grades.slice(0, 13).indexOf(grade) != -1
  }
  service.isSeniorStudent = function (grade) {
    const grades = _.map(service.grades, 'value')
    return grades.slice(10, 16).indexOf(grade) != -1
  }
  return service
}
